import React from 'react';
import styled from 'styled-components';
import FooterButton from './FooterButton';
import SubmitButton from './SubmitButton';

type ActionsType = {
  handleBack: () => void;
  completeRecordSelection: () => void;
  completeInformationSelection: () => void;
};

type Props = {
  acknowledged: boolean;
  actions: ActionsType;
  currentPage: string;
  processing: boolean;
  valid: boolean;
  selectedItems: number;
  exceedsMaxDocuments: boolean;
};

const FooterWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.5rem;
`;

const Footer = ({
  acknowledged,
  actions,
  currentPage,
  processing,
  valid,
  selectedItems,
  exceedsMaxDocuments,
}: Props) => {
  const footerMapping = {
    confirmSelect: 'select_without_back',
    chargeSelect: 'multi_select',
    generalInformation: 'information',
    caseInformation: 'information',
    summary: 'summary',
  };
  const footerType = footerMapping[currentPage as keyof typeof footerMapping];

  return (
    <FooterWrapperStyled data-testid='candidate-story-footer'>
      <div>
        {footerType !== 'select_without_back' && (
          <FooterButton
            kind='tertiary'
            type='button'
            onClickFunction={actions.handleBack}
            value='buttons.back'
            testId='candidate-story-footer-back-button'
            processing={processing}
            disabled={false}
          />
        )}
      </div>
      <div data-testid='candidate-story-footer-button-wrapper'>
        {footerType === 'summary' && (
          <SubmitButton
            processing={processing}
            valid={valid}
            acknowledged={acknowledged}
            exceedsMaxDocuments={exceedsMaxDocuments}
          />
        )}
        {footerType === 'multi_select' && (
          <FooterButton
            kind='primary'
            type='button'
            onClickFunction={actions.completeRecordSelection}
            value='buttons.continue'
            testId='candidate-story-footer-continue-button'
            processing={processing}
            disabled={!valid || !selectedItems}
          />
        )}
        {footerType === 'information' && (
          <FooterButton
            kind='primary'
            type='button'
            onClickFunction={actions.completeInformationSelection}
            value='buttons.continue'
            testId='candidate-story-footer-continue-button'
            processing={processing}
            disabled={!valid}
          />
        )}
      </div>
    </FooterWrapperStyled>
  );
};

export default Footer;
